import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const DWAuthContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api/dw`;
const TOKEN_KEY = 'dw_token';

export const DWAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(sessionStorage.getItem(TOKEN_KEY));

  useEffect(() => {
    const initAuth = async () => {
      const storedToken = sessionStorage.getItem(TOKEN_KEY);
      if (storedToken) {
        try {
          const response = await axios.get(`${API}/auth/me`, {
            headers: { Authorization: `Bearer ${storedToken}` }
          });
          setUser(response.data);
          setToken(storedToken);
        } catch (e) {
          console.error('DW auth check failed:', e.message);
          sessionStorage.removeItem(TOKEN_KEY);
          setToken(null);
          setUser(null);
        }
      }
      setLoading(false);
    };
    initAuth();
  }, []);

  const login = async (email, password) => {
    const response = await axios.post(`${API}/auth/login`, { email, password });
    const { token: newToken, user: userData } = response.data;
    sessionStorage.setItem(TOKEN_KEY, newToken);
    setToken(newToken);
    setUser(userData);
    return userData;
  };

  const register = async (email, password, name, invite_code) => {
    const response = await axios.post(`${API}/auth/register`, { email, password, name, invite_code });
    const { token: newToken, user: userData } = response.data;
    sessionStorage.setItem(TOKEN_KEY, newToken);
    setToken(newToken);
    setUser(userData);
    return userData;
  };

  const logout = () => {
    sessionStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setUser(null);
  };

  const setOnboardingTrack = async (track) => {
    const response = await axios.post(
      `${API}/auth/onboarding-track`,
      { track },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setUser((prev) => (prev ? { ...prev, onboarding_track: response.data.track } : prev));
    return response.data;
  };

  const getAuthHeaders = () => ({
    Authorization: `Bearer ${token}`
  });

  return (
    <DWAuthContext.Provider value={{ user, token, loading, login, register, logout, getAuthHeaders, setOnboardingTrack }}>
      {children}
    </DWAuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(DWAuthContext);
  if (!context) {
    throw new Error('useAuth must be used within DWAuthProvider');
  }
  return context;
};
